module.exports = {
  title: 'Add to Cart Animation with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2023-02-08',
  slug: 'add-to-cart',
  tags: ['reanimated', 'gesture-handler'],
};
